const STAGING_URL = "https://staging.praccel.com";
const PRODUCTION_URL = "https://praccel.com";

// Detect if we are on the production domain
const isProduction = 
  window.location.hostname === "praccel.com" ||
  window.location.hostname === "www.praccel.com";

// Use Production URL if on production domain, otherwise default to Staging
const baseURL = isProduction ? PRODUCTION_URL : STAGING_URL;

export { isProduction };
export default baseURL;

